import { Role } from '@app/shared/models/user/role';
import { Entity, EntityConfiguration, Schema } from '@technocom/data/core';

export class RoleDetails extends Entity<RoleDTO, number | Role> {
  static readonly options: EntityConfiguration = Entity.extendOptions({
    title: 'Роль',
    serverUrl: '/auth-controller/role',
  });

  static readonly schema: Schema = Entity.extend<RoleDTO>({
    text: 'name',
    fields: {
      id: {
        type: Number,
        title: 'ID',
        options: {
          order: 0,
        },
      },
      name: {
        type: String,
        title: 'Наименование роли',
        options: {
          order: 10,
        },
      },
    },
  });
}

export interface RoleDTO {
  id?: number | Role;
  name: string;
}
